<template>
  <div class="main">
    <div class="pageTitle">
     <p>帮助</p>
    </div>
    <div class="searchArea">
        <p style="font-size: 14px;margin-top:10px;line-height:30px;">
            技术支持、商务合作、定制开发、私有化部署<br/>
            E-mail：cao.silhouette@msn.com<br/>
            微信：sheng-incog<br/>

        </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      
    };
  },
  mounted(){
      
  },
  methods: {
   
    }
};
</script>




// WEBPACK FOOTER //
// src/views/help/help.vue